import React from 'react';
import { Nav, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useLocation,useNavigate  } from 'react-router-dom';
import { ChevronLeft, ChevronRight, LogOut, User } from 'lucide-react';
import { menuItems } from '../data/menuItems';
import {  logout } from '../../../utils/auth';
import '../css/Sidebar.css';


const Sidebar = ({ collapsed, onToggle }) => {
  const location = useLocation();
 const navigate = useNavigate();

  const isActive = (path, exact = false) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

const handleLogout = () => {
  logout();
  navigate('/login');
};
  const handleProfile = () => {
    console.log('profile');
    
  };

  return (
    <div className={`sidebar-modern ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header-modern">
        {!collapsed && <h3 className="logo-text">✨ AdminHub</h3>}
        <Button 
          variant="ghost" 
          className="toggle-btn"
          onClick={onToggle}
        >
          {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </Button>
      </div>

      <div className="sidebar-nav-wrapper">
        <Nav className="flex-column sidebar-nav">
          {menuItems.map((item, index) => {
            if (item.subItems) {
              return (
                <div key={index} className="nav-group">
                  <div className={`nav-group-trigger ${isActive(item.path) ? 'active' : ''}`}>
                    <item.icon size={20} />
                    {!collapsed && <span>{item.text}</span>}
                  </div>
                  {!collapsed && (
                    <div className="nav-group-items">
                      {item.subItems.map((subItem, subIndex) => (
                        <Link
                          key={subIndex}
                          to={subItem.path}
                          className={`nav-subitem ${isActive(subItem.path, true) ? 'active' : ''}`}
                        >
                          {subItem.icon && <subItem.icon size={16} />}
                          <span>{subItem.text}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              );
            }

            const linkContent = (
              <Link
                to={item.path}
                className={`nav-link-modern ${isActive(item.path, item.exact) ? 'active' : ''}`}
              >
                <item.icon size={20} />
                {!collapsed && <span>{item.text}</span>}
              </Link>
            );

            if (collapsed) {
              return (
                <OverlayTrigger
                  key={index}
                  placement="right"
                  overlay={<Tooltip id={`tooltip-${index}`}>{item.text}</Tooltip>}
                >
                  <div>{linkContent}</div>
                </OverlayTrigger>
              );
            }

            return <div key={index}>{linkContent}</div>;
          })}
        </Nav>
      </div>

      {/* Footer with proper buttons */}
      <div className="sidebar-footer-modern">
        <button className="profile-footer-btn" onClick={handleProfile}>
          <User size={20} />
          {!collapsed && <span>Profile</span>}
        </button>
        <button className="logout-footer-btn" onClick={handleLogout}>
          <LogOut size={20} />
          {!collapsed && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;